import { HoldingType } from '@ddt-web/config';
import { PortfolioConstants } from '@ddt-web/domain';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';


export class PartnerAnalyticsUtil {

	/**
	 * provides the composition of a unsupported/dirty partner portfolio
	 * can be extended for a clean partner portfolio later
	 * @static
	 * @param {*} portfolio
	 * @returns {string}
	 * @memberof PartnerAnalyticsUtil
	 */
	public static getPartnerPortfolioComposition(portfolio: any): string {
		const porfolioCompositionArr = [];
		if (portfolio && !isEmpty(portfolio.children)) {

			const porfolioCompositionCountObj = {
				sec: 0, mm: 0, apm: 0, sma: 0, ac: 0
			};

			const children = get(portfolio, 'children', []);


			children.forEach(child => {
				// in case of asset class we can get the count from the security substitute's substitutedFrom array
				if (get(child, 'positionType') === PortfolioConstants.POSITION_TYPE.SUBSTITUTED) {
					const substitutedAssetClasses = get(child, 'substitutedFrom.assetClass', []);
					porfolioCompositionCountObj['ac'] = substitutedAssetClasses.length;
				} else {
					const childType = get(child, 'originPlatform.type');
					const isHoldingInvalid = get(child, 'positionType') === 'INVALID';
					if (isHoldingInvalid) {
						switch (childType) {
							case HoldingType.APM:
								porfolioCompositionCountObj['apm']++;
								break;
							case HoldingType.SECURITY:
								porfolioCompositionCountObj['sec']++;
								break;
							case HoldingType.MANAGED_MODEL:
								porfolioCompositionCountObj['mm']++;
								break;
							case HoldingType.SMA:
								porfolioCompositionCountObj['sma']++;
								break;
						}
					}
				}

			});
			Object.keys(porfolioCompositionCountObj).forEach(key => {
				const count = porfolioCompositionCountObj[key];
				if (count > 0) {
					porfolioCompositionArr.push(key + ':' + count);
				}
			});
		}
		return porfolioCompositionArr.join('|');
	}
}
